export default __webpack_public_path__ + "static/media/dsl.e5f7ff7e.jpg";